import makeMainView from "../../shared/containers/make_main_view";

import Overview from "./main_components/overview";
import { FOCUS_VIEW_TYPES } from "../actions/focus_view";

const mainComponents = {
  overview: Overview
};

export default makeMainView(mainComponents, FOCUS_VIEW_TYPES, { overview: true });
